/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerRightUpDouble = createReactComponent(
  "corner-right-up-double",
  "IconCornerRightUpDouble",
  [
    ["path", { d: "M5 19h6a3 3 0 0 0 3 -3v-7", key: "svg-0" }],
    ["path", { d: "M10 13l4 -4l4 4m-8 -5l4 -4l4 4", key: "svg-1" }]
  ]
);

export { IconCornerRightUpDouble as default };
//# sourceMappingURL=IconCornerRightUpDouble.js.map
